import {
  LegacyWarningSetting,
  UpdateLegacyWarningSettingBodyLegacyWarningSettings,
} from "@/lib/api";

export const toUpdateWarningSettings = (
  warnings?: LegacyWarningSetting,
): UpdateLegacyWarningSettingBodyLegacyWarningSettings => ({
  warnings_water_authorities: warnings?.warnings_water_authorities ?? undefined,
  warnings_provinces: warnings?.warnings_provinces ?? undefined,
});
